// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"9f2d3d4e","626":"00775779","629":"2f6ade45","868":"fa81c5fc","991":"befbab0a"}[chunkId] + ".chunk.css";
};